import { collection, getDocs } from "firebase/firestore"
import { db } from "../firebase/firebase-config"

export const loadNotes = async (uid) => {

    const notes = []

    try {
        const notesSnap = await getDocs(collection(db, `${uid}/journal/notes`))

        notesSnap.forEach(childSnap => {
            notes.push({
                id: childSnap.id,
                ...childSnap.data()
            })
        })
    } catch (e) {
        console.log(e.code)
    }

    return notes
}